import React, { Fragment, Component } from 'react'
import PropTypes from 'prop-types'
import Button from '@material-ui/core/Button'
import Dialog from '../../components/IdentifiedDialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import withMobileDialog from '@material-ui/core/withMobileDialog'
import Input from '@material-ui/core/Input'
import InputLabel from '@material-ui/core/InputLabel'
import FormControl from '@material-ui/core/FormControl'
import { connect } from 'react-redux'
import { readingTimeActions, messageActions } from '../../actions'
import { withStyles } from '@material-ui/core/styles'
import CircularProgress from '@material-ui/core/CircularProgress'
import Typography from '@material-ui/core/Typography'
import { readOnly } from '../../utils/permissions'
import { Slider } from 'material-ui-slider'

const styles = theme => ({
  box: theme.mixins.gutters({
    paddingTop: 16,
    paddingBottom: 16,
    margin: 'auto',
    width: '80%',
    maxWidth: '400px',
    background: 'blue'
  }),
  errorMessage: {
    position: 'absolute',
    bottom: '-22px',
    left: 0
  },
  wrapperLoader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minWidth: '280px',
    width: '100%',
    height: '100%',
    minHeight: '200px'
  },
  formGroup: {
    padding: '12px 0'
  },
  root: {
    display: 'flex',
    minHeight: '100%',
    padding: '16px 0',
    boxSizing: 'border-box',
    flexDirection: 'column',
    background: '#fafafa'
  },
  formControl: {
    margin: '14px 0'
  }
})

class EditModal extends Component {
  constructor() {
    super()
    this.canRun = true

    this.state = {
      isRangeAvailable: true
    }
  }

  runSigleTime = fun => {
    if (this.canRun) fun()
    this.canRun = false
  }

  handleSave = readingTime => {
    const { onClose, addReadingTime, editReadingTime, changeMessage } = this.props
    if (readingTime._id) {
      editReadingTime(readingTime)
        .then(res => {
          changeMessage({ message: 'Alteração realizada com sucesso.' })
          onClose()
        })
        .catch(({ data: { message = '' } = {} }) => {
          changeMessage({ message })
        })
    } else {
      addReadingTime(readingTime)
        .then(res => {
          changeMessage({ message: 'Cadastro realizado com sucesso.' })
          onClose()
        })
        .catch(({ data: { message = '' } = {} }) => {
          changeMessage({ message })
        })
    }
  }

  handleSubmit = (e, readingTime) => {
    e.preventDefault()
    const { setReadingTimeFormTouched } = this.props

    if ((this.props.readingTimeFormErrors || {}).valid) {
      this.handleSave(readingTime)
    } else {
      setReadingTimeFormTouched()
    }
    return false
  }

  handleRange = selectedRange => {
    const [begin, end] = selectedRange

    const { originalRange, ranges } = this.props

    if (!!originalRange.length) {
      const [originBegin, originEnd] = originalRange

      if (begin >= originBegin && end <= originEnd) {
        this.setState({ isRangeAvailable: true })
        return
      }

      // does new begin value conflict with another value
      if (end >= originBegin && end <= originEnd && begin < originBegin) {
        for (let [rangeBegin, rangeEnd] of ranges) {
          if (begin >= rangeBegin && begin <= rangeEnd) {
            this.setState({ isRangeAvailable: false })
            return
          }
        }
      }

      // does new end value conflict with another value
      if (begin >= originBegin && begin <= originEnd && end > originEnd) {
        for (let [rangeBegin, rangeEnd] of ranges) {
          if (end >= rangeBegin && end <= rangeEnd) {
            this.setState({ isRangeAvailable: false })
            return
          }
        }
      }

      // last but not least if any range falls into the selected values excluding origin values
      for (let [rangeBegin, rangeEnd] of ranges) {
        if (
          (rangeBegin >= begin && rangeBegin <= end && rangeBegin !== originBegin) ||
          (rangeEnd >= begin && rangeEnd <= end && rangeEnd !== originEnd)
        ) {
          this.setState({ isRangeAvailable: false })
          return
        }
      }

      this.setState({ isRangeAvailable: true })
      return
    }

    for (let [rangeBegin, rangeEnd] of ranges) {
      // between ranges
      if ((begin >= rangeBegin && begin <= rangeEnd) || (end >= rangeBegin && end <= rangeEnd)) {
        this.setState({ isRangeAvailable: false })
        return
      } // range is between selected range
      else if (
        (rangeBegin >= begin && rangeBegin <= end) ||
        (rangeEnd >= begin && rangeEnd <= end)
      ) {
        this.setState({ isRangeAvailable: false })
        return
      }
    }

    this.setState({ isRangeAvailable: true })
  }

  clearErrors = () => {
    this.setState({ formErrors: {} })
  }

  componentWillMount() {
    const { fetchRanges } = this.props

    fetchRanges()
  }

  componentDidUpdate({ readingTime: previousReadingTime }) {
    const { readingTime: currentReadingTime, formSchemaType, ranges } = this.props

    const { handleRange, runSigleTime } = this

    const stringify = object => JSON.stringify(object)

    const { tempo } = currentReadingTime

    if (!!ranges.length) {
      runSigleTime(() => {
        if (formSchemaType === 'add') {
          handleRange(tempo)
        }
      })
    }

    if (stringify(currentReadingTime) !== stringify(previousReadingTime)) handleRange(tempo)
  }

  render() {
    const {
      fullScreen,
      onClose,
      open = false,
      classes,
      readingTime,
      handleChangeReadingTime,
      loadingReadingTime,
      readingTimeFormErrors,
      formTouched,
      token,
      loadingRanges,
      ranges,
      originalRange,
      fetchRangeError
    } = this.props

    const { handleSubmit, handleRange, clearErrors } = this
    const isReadOnly = readOnly('tempos_leitura', token)

    const { isRangeAvailable } = this.state

    return (
      <div>
        <Dialog
          modalId={readingTime._id ? 'tempo-leitura-editar' : 'tempo-leitura-novo'}
          modalParams={{ registro: readingTime._id }}
          fullScreen={fullScreen}
          fullWidth
          open={open}
          onClose={onClose}
          className={classes.dialog}
        >
          {loadingReadingTime ? (
            <div className={classes.wrapperLoader}>
              <CircularProgress />
            </div>
          ) : (
            <Fragment>
              <DialogTitle id={(readingTime._id ? 'tempo-leitura-editar' : 'tempo-leitura-novo') + '-title'}>
                {isReadOnly ? (
                  'Tempo de leitura'
                ) : (
                  <Fragment>
                    {readingTime._id ? 'Editar tempo de leitura' : 'Cadastrar tempo de leitura'}
                  </Fragment>
                )}
              </DialogTitle>

              <DialogContent>
                <form
                  id={'readingTime-form'}
                  noValidate
                  onSubmit={e => {
                    handleSubmit(e, readingTime)
                  }}
                >
                  <FormControl
                    error={
                      !((readingTimeFormErrors.fields || {})['nome'] || {}).valid && formTouched
                    }
                    className={classes.formControl}
                    fullWidth
                  >
                    <InputLabel htmlFor="field-nome">Nome</InputLabel>
                    <Input
                      disabled={isReadOnly}
                      fullWidth
                      placeholder="Leitura simples"
                      required={'required'}
                      type="text"
                      onChange={e => {
                        clearErrors()
                        handleChangeReadingTime({
                          ...readingTime,
                          nome: e.target.value,
                          chave: (e.target.value || '')
                            .toLowerCase()
                            .normalize('NFD')
                            .replace(/[\u0300-\u036f]/g, '')
                            .replace(/ /g, '_')
                        })
                      }}
                      value={readingTime.nome}
                      autoFocus
                      id="field-nome"
                    />
                    {!((readingTimeFormErrors.fields || {})['nome'] || {}).valid && formTouched ? (
                      <Typography className={classes.errorMessage} noWrap color={'error'}>
                        {((readingTimeFormErrors.fields || {})['nome'] || {}).errorMessage}
                      </Typography>
                    ) : null}
                  </FormControl>
                  {loadingRanges ? (
                    <CircularProgress />
                  ) : (
                    <React.Fragment>
                      <FormControl
                        error={
                          !((readingTimeFormErrors.fields || {})['tempo'] || {}).valid &&
                          formTouched
                        }
                        className={classes.formControl}
                        fullWidth
                      >
                        <InputLabel htmlFor="field-tempo">
                          Tempo de leitura ({readingTime.tempo[0]} a {readingTime.tempo[1]} minutos)
                        </InputLabel>
                      </FormControl>
                      <div style={{ paddingBottom: '16px' }} />
                      <Slider
                        range
                        direction="horizontal"
                        defaultValue={[0, 20]}
                        min={0}
                        max={300}
                        color="#002d72"
                        value={readingTime.tempo}
                        onChangeComplete={range =>
                          handleChangeReadingTime({
                            ...readingTime,
                            tempo: range
                          })
                        }
                        id="field-tempo"
                      />
                      <div style={{ marginTop: '-32px' }}>
                        <FormControl
                          error={
                            (!((readingTimeFormErrors.fields || {})['tempo'] || {}).valid &&
                              formTouched) ||
                            !isRangeAvailable
                          }
                          className={classes.formControl}
                          fullWidth
                        >
                          {(!((readingTimeFormErrors.fields || {})['tempo'] || {}).valid &&
                            formTouched) ||
                          !isRangeAvailable ? (
                            <Typography className={classes.errorMessage} noWrap color={'error'}>
                              {((readingTimeFormErrors.fields || {})['tempo'] || {}).errorMessage ||
                                (!isRangeAvailable &&
                                  'O intervalo selecionado não está disponível.')}
                            </Typography>
                          ) : null}
                        </FormControl>
                      </div>
                    </React.Fragment>
                  )}
                </form>
              </DialogContent>
              <DialogActions>
                <Button onClick={onClose} color="default">
                  {isReadOnly ? 'Voltar' : 'Cancelar'}
                </Button>
                {!isReadOnly && (
                  <Button
                    type={'submit'}
                    form={'readingTime-form'}
                    color="primary"
                    variant="raised"
                    disabled={!isRangeAvailable}
                  >
                    Salvar
                  </Button>
                )}
              </DialogActions>
            </Fragment>
          )}
        </Dialog>
      </div>
    )
  }
}

EditModal.propTypes = {
  fullScreen: PropTypes.bool.isRequired
}

const mapStateToProps = state => {
  return {
    readingTime: state.readingTimes.selected,
    originalRange: state.readingTimes.originalRange,
    loadingReadingTime: state.readingTimes.loading,
    loadingRanges: state.readingTimes.loadingRanges,
    ranges: state.readingTimes.ranges,
    fetchRangeError: state.readingTimes.fetchRangeError,
    readingTimeFormErrors: state.readingTimes.formErrors,
    formTouched: state.readingTimes.formTouched,
    formSchemaType: state.readingTimes.formSchemaType,
    token: state.auth.token
  }
}

const mapDispatchToProps = dispatch => {
  return {
    openModal: () => {
      dispatch(readingTimeActions.openModal())
    },
    closeModal: () => {
      dispatch(readingTimeActions.closeModal())
    },
    handleChangeReadingTime: readingTime => {
      dispatch(readingTimeActions.handleChange(readingTime))
    },
    addReadingTime: readingTime => {
      return dispatch(readingTimeActions.add(readingTime))
    },
    editReadingTime: readingTime => {
      return dispatch(readingTimeActions.edit(readingTime))
    },
    setReadingTimeFormTouched: readingTime => {
      dispatch(readingTimeActions.setFormTouched())
    },
    fetchRanges: () => {
      return dispatch(readingTimeActions.fetchRanges())
    },
    changeMessage: ({ message }) => {
      dispatch(messageActions.changeMessage({ message }))
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withMobileDialog()(withStyles(styles)(EditModal)))



// WEBPACK FOOTER //
// ./src/containers/ReadingTime/EditModal.js